import { commanServicer } from "./common.services";

async function  getclientproductlist() {
    return await commanServicer.fetchRequest('', true, 'license/getclientproductlist', 'GET');
}

async function  GetProdKeyListByClientID(clientId: number) {
    return await commanServicer.fetchRequest('', true, 'license/getprodkeylistbyclientId/'+clientId, 'GET');
}

async function  getProductListDropMenu() {
    return await commanServicer.fetchRequest('', true, 'license/getproductlistdropmenu', 'GET');
}

async function SaveorUpdateclient(clientData : any) {
    return await commanServicer.fetchRequest(JSON.stringify(clientData), true, 'license/registerclient','POST');
}
 
async function UpdateProductKeyExpireDate(productData : any) {
    return await commanServicer.fetchRequest(JSON.stringify(productData), true, 'license/updateproductkeyexpiredate','POST');
}

async function InsertProductKeyList(productKeyList : any) {
    return await commanServicer.fetchRequest(JSON.stringify(productKeyList), true, 'license/insertproductkeylist','POST');
}

async function GenerateDyanmicProductKeyList(productKeyGenerateParams : any) {
    return await commanServicer.fetchRequest(JSON.stringify(productKeyGenerateParams), true, 'license/generatedyanmicproductkey','POST');
}

async function  GetProductKeyDetail() {
    return await commanServicer.fetchRequest('', true, 'license/getprodkeylist', 'GET');
}

export const clientMasterServicer = {
    getclientproductlist,
    GetProdKeyListByClientID,
    getProductListDropMenu,
    SaveorUpdateclient,
    UpdateProductKeyExpireDate,
    InsertProductKeyList,
    GenerateDyanmicProductKeyList,
    GetProductKeyDetail
}